import React, { useContext, useMemo } from 'react';
import useTimeZoneContext from '@contexts/useTimeZoneContext';
import { subcontractorIcon } from '../../../utils/functions/subcontractor.functions';
import { technicianAvatar } from '../../../utils/functions/technician.functions';
import { blackOrWhiteForeground } from '../../../utils/colors';
import { CalendarContext } from '../CalendarContext';
function Event({ fcProps }) {
    var _a, _b, _c;
    const { state: { statuses, detailed, range } } = useContext(CalendarContext);
    const { timezone } = useTimeZoneContext();
    const event = useMemo(() => (Object.assign(Object.assign({}, fcProps.event.extendedProps), { id: fcProps.event.id, title: fcProps.event.title, start: fcProps.event.startStr, end: fcProps.event.endStr })), [fcProps]);
    const status = useMemo(() => statuses[event.groupStatus] && event.statusObject, [statuses, event.groupStatus, event.statusObject]);
    const { technician, assignee } = event;
    const className = useMemo(() => `cal__event ${detailed ? '--detailed' : ''} ${status ? '--status' : ''} ${event.type === 'TimeOff' ? '--holiday' : ''} ${!(technician === null || technician === void 0 ? void 0 : technician.id) ? '--unassigned' : ''}`, [detailed, status, event.technician]);
    const rightSideIcon = useMemo(() => {
        if (status)
            return React.createElement(StatusIcon, { status: status });
        if (assignee.subcontractor !== undefined) {
            return subcontractorIcon(assignee.subcontractor, 16);
        }
        return technicianAvatar(assignee.technician, 16);
    }, [status, assignee]);
    return (React.createElement("div", { className: className, style: {
            color: status ? '#000' : blackOrWhiteForeground(((_a = assignee === null || assignee === void 0 ? void 0 : assignee.technician) === null || _a === void 0 ? void 0 : _a.color) || ((_b = assignee === null || assignee === void 0 ? void 0 : assignee.subcontractor) === null || _b === void 0 ? void 0 : _b.color))
        } },
        React.createElement("div", { className: "event__crux" },
            React.createElement("span", { className: "event__type" },
                event.type === 'Inspection' && React.createElement("i", { className: "fa-light fa-clipboard-check" }),
                event.type === 'Visit' && React.createElement("i", { className: "fa-light fa-screwdriver-wrench" }),
                event.type === 'TimeOff' && React.createElement("i", { className: "fa-light fa-umbrella-beach" })),
            React.createElement("span", { className: "event__time" },
                event.type === 'TimeOff' && event.title,
                event.type !== 'TimeOff' &&
                    new Date(event.start).toLocaleTimeString('en-US', {
                        timeZone: timezone,
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: true
                    }))),
        (event.type !== 'TimeOff' ||
            (event.type === 'TimeOff' && !(technician === null || technician === void 0 ? void 0 : technician.id) && ((_c = range === null || range === void 0 ? void 0 : range.view) === null || _c === void 0 ? void 0 : _c.type) === 'dayGridMonth')) && (React.createElement("div", { className: "event__title" }, event.title)),
        React.createElement("div", { className: "event__indicate" }, rightSideIcon),
        detailed && event.description && React.createElement("div", { className: "event__details" }, event.description)));
}
function StatusIcon({ status }) {
    return (React.createElement("span", { className: "qmb-status", style: { color: status.color } },
        React.createElement("i", { className: status.icon })));
}
export default Event;
